import React from 'react';
import { pure } from 'recompose';
import config from 'config';
import { froalaDefaultConfig, froalaConfigWithoutImages } from 'config/constants/wysiwyg';
 
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
// import 'font-awesome/css/font-awesome.css'; // it need for FroalaEditor - repalced through cdn
import FroalaEditor from 'react-froala-wysiwyg';
//import 'froala-editor/js/third_party/image_aviary.min'; // Import this plugin last. Otherwise, this causes an error
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/third_party/image_tui.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/colors.min.js';
 
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/quote.min.js';
 
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/print.min.js';
 
// import 'froala-editor/js/plugins/undo.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/help.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import './style.scss';
 
const { constants } = config;
const { API } = constants;
 
const FroalaWysisyg = ({
  tag = 'textarea',
  config,
  model = '',
  onModelChange,
  withoutImages = false,
  onInitialized,
}) => {
  const configuration = config || froalaDefaultConfig;
  configuration.imageUploadURL = `${API.EXTRA_URL.SARITASA}/api/v1/images`;

  const events = {
    ...(configuration.events || {}),
    initialized: function () {
      if (typeof onInitialized === 'function') {
        onInitialized(this);
      }
    },
  };
 
  return (
    <FroalaEditor
      tag={tag}
      config={{ ...(withoutImages ? froalaConfigWithoutImages : configuration), events}}
      model={model}
      onModelChange={onModelChange}
    />
 
  );
};
 
export default pure(FroalaWysisyg);